/**
 * File gleam.js.
 * Handles logic for the Gleam CTA/script/modal
 */

const gleamCtaForm = document.querySelectorAll('.gleam__cta-form');
const gleamModal = document.querySelector('.gleam__modal');
const gleamCtaInput = document.querySelectorAll('.gleam__cta-input');
const gleamCtaBtn = document.querySelectorAll('.gleam__cta-btn');
let gleamLoaded = false;

function brightenButton(e) {
  const activeClass = 'gleam__cta-submit--active';
  if (e.target.value) {
    e.target.classList.add(activeClass);
  } else {
    e.target.classList.remove(activeClass);
  }
}

function loadGleamScript(e) {
  if (gleamLoaded) return;

  let ctaVal = '';
  const script = document.createElement('script');
  script.src = 'https://widget.gleamjs.io/e.js';
  script.async = true;

  if (e.target.querySelector('.gleam__cta-input')) {
    ctaVal = e.target.querySelector('.gleam__cta-input').value;
  }

  // if Gleam script loaded, pre-fill widget in modal
  script.onload = () => {
    window.Gleam = window.Gleam || [];
    Gleam.push(['email', ctaVal]);
  };

  // if Gleam script failed to load, restore modal style
  script.onerror = () => {
    gleamModal.classList.remove('gleam__modal--unstyled');
  };

  // append Gleam script
  gleamModal.appendChild(script);
  gleamLoaded = true;
}

// Inits
if (gleamCtaInput.length > 0) {
  for (let i = 0; i < gleamCtaInput.length; i++) {
    gleamCtaInput[i].addEventListener('keyup', brightenButton);
  }
}

if (gleamCtaForm.length > 0) {
  for (let f = 0; f < gleamCtaForm.length; f++) {
    gleamCtaForm[f].addEventListener('submit', function (e) {
      e.preventDefault();
      loadGleamScript(e);
      showModal(gleamModal);
    });
  }
}

if (gleamCtaBtn.length > 0) {
  for (let b = 0; b < gleamCtaBtn.length; b++) {
    gleamCtaBtn[b].addEventListener('click', function (e) {
      e.preventDefault();
      loadGleamScript(e);
      showModal(gleamModal);
    });
  }
}
